export const ListDistributionTypes = (resultHandler) => {
  let getAPI = "/api/distributions/";
  if (process.env.NODE_ENV !== "production") {
    getAPI = "http://localhost:7071/api/distributions/";
  }
  fetch(getAPI, {
    method: "GET",
    headers: {
      Accept: "application/json, text/plain, */*",
      "Content-Type": "application/json",
    },
  }).then((response) => {
    if (!response.ok) {
      response.text().then((text) => {
        throw Error(response.statusText + ": " + text);
      });
    } else {
      response.json().then((parsedResponse) => resultHandler(parsedResponse));
    }
  });
};
